export const ADD_REQUEST_THUMBNAIL_SET_ID = 'add-request-thumbnails-set-id'
export const REMOVE_REQUEST_THUMBNAIL_SET_ID = 'remove-thumbnail-set-id'
export const UPDATE_THUMBNAIL_SET = 'update-thumbnail-set'
